// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d963a6a4","453":"e7b96d99","455":"5cf92403","977":"ee0d873f"}[chunkId] + ".chunk.js";
};